export default __webpack_public_path__ + "static/media/7.c67b0692.jpg";